const rankings = [
  {
    rank: 1,
    title: '长安十二时辰之风起云涌',
    tag: '古装悬疑',
    hot: '本周播放量 3280 万',
    change: 'up',
  },
  {
    rank: 2,
    title: '暗夜追光',
    tag: '犯罪悬疑',
    hot: '本周播放量 2950 万',
    change: 'up',
  },
  {
    rank: 3,
    title: '锦瑟年华',
    tag: '年代情感',
    hot: '本周播放量 2610 万',
    change: 'down',
  },
  {
    rank: 4,
    title: '山海情缘',
    tag: '现实题材',
    hot: '本周播放量 2380 万',
    change: 'up',
  },
  {
    rank: 5,
    title: '风起洛阳之盛世华章',
    tag: '古装传奇',
    hot: '本周播放量 2150 万',
    change: 'new',
  },
];

export default function RankingSection() {
  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-secondary-500 text-background-50';
    if (rank === 3) return 'bg-primary-400 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  const getChangeIcon = (change: string) => {
    if (change === 'up') return 'ri-arrow-up-line text-primary-500';
    if (change === 'down') return 'ri-arrow-down-line text-secondary-500';
    return 'ri-add-line text-accent-500';
  };

  return (
    <section id="ranking" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热播榜单</h2>
          <p className="text-sm text-foreground-500">本周最受欢迎的热播剧集排行</p>
        </div>
        <div className="space-y-3">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div
                className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-lg font-bold flex-shrink-0 ${getRankStyle(item.rank)}`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.hot}</span>
                </div>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1.5">
                <i className={`text-sm ${getChangeIcon(item.change)}`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}